import Svg, { Path } from "react-native-svg";
import { GetProps } from "tamagui";

const OrdersIcon = ({ color, ...props }: GetProps<typeof Svg>) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <Path
      d="M7 16L17 16M7 20L17 20M7 10.2678L7 7.31827M7 7.31827L7 4.7374C7 4.33014 7.33014 4 7.73739 4L9.02783 4C9.94415 4 10.687 4.74282 10.687 5.65914C10.687 6.57545 9.94415 7.31827 9.02783 7.31827L8.10609 7.31827M7 7.31827L8.10609 7.31827M12.8991 8.79306L11.24 10.4522M11.24 10.4522L9.58088 12.1113M11.24 10.4522L8.10609 7.31827M11.24 10.4522L12.8991 12.1113M5 23L19 23C19.5523 23 20 22.5523 20 22L20 2C20 1.44772 19.5523 1 19 1L5 1C4.44772 1 4 1.44772 4 2L4 22C4 22.5523 4.44772 23 5 23Z"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </Svg>
);

export default OrdersIcon;
